import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';

class ErrorBoundary extends Component {
  state = { eventId: null, hasError: false };

  setUserInfo = async () => {
    Sentry.configureScope(scope => {
      scope.setUser({ _id: 'TODO: Arreglar ID' });
    });
  };

  componentDidMount() {
    this.setUserInfo();
  }

  static getDerivedStateFromError() {
    // console.log('ENTRE:');
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    Sentry.withScope(scope => {
      scope.setExtras(info);
      const eventId = Sentry.captureException(error);
      this.setState({ eventId, hasError: true });
    });
  }

  render() {
    const { eventId, hasError } = this.state;
    if (hasError) {
      return (
        <div>
          <h2>Ocurrio un error.</h2>
          <a
            onClick={() =>
              Sentry.showReportDialog({
                eventId,
                title:
                  'Al parecer estamos teniendo inconvenientes. Reporta el error.',
                lang: 'es',
              })
            }
          >
            Comentanos lo que sucedio.
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
